import axios from 'axios'
import { useAuthHeader, useAuthUser } from 'react-auth-kit'
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import Table from '../../usables/Table'
import Input from '../../usables/small/Input'
import Modal from '../../usables/Modal'
import Spinner from '../../usables/small/Spinner'
import ClosingAlert from '../../usables/Alert'
import Button from '../../usables/small/ButtonReal'
import Select from 'react-select'

export default function Classes() {
  const auth  = useAuthHeader()
  const authUser  = useAuthUser()
  const [classes, setClasses] = useState([])
  const [showError, setShowError] = useState(false)
  const [dataLoaded, setDataLoaded] = useState({done: false, sucssess: false, items: 0})
  const [formData, setFormData] = useState({name: '', grade: ''})
  const [errorMsg, setErrorMsg] = useState('Nepavyko įrašyti reikšmės')
  const [showError2, setShowError2] = useState(false)

  const tableColumns = [{
    Header: "Klasės",
    columns: [
      {
        Header: "Klasė",
        accessor: "name"
      },
      {
        Header: "Auklėtojas",
        accessor: "teacher.person.name"
      },
      {
        Header: "Veiksmai",
        accessor: "action"
      },
    ]
  }]

  const config = {
    headers: {
      Authorization: auth()
    }
  }

  const sortStudents = () => {
    axios.post(process.env.REACT_APP_API + '/class/sort', {}, config)
      .then((res)=>{
        if(res.status === 200){
          setShowError(true)
        }
      })
      .catch((err) => {
        setErrorMsg(err.response.data.message)
        setShowError2(true)
      })
    }
  const createClass = () => {
    axios.post(process.env.REACT_APP_API + '/class', formData, config)
      .then((res)=>{
        if(res.status === 200){
          res.data.class.action = <Link className='text-violet-500 hover:text-violet-700' to={'/dashboard/classes/' + res.data.class.id}>Daugiau</Link>
          setClasses(classe => [...classe, res.data.class])
        }
      })
      .catch((err) => {
        setErrorMsg(err.response.data.message)
        setShowError2(true)
      })
    }

  useEffect(() => {
    axios.get(process.env.REACT_APP_API + '/class', config)
    .then(res => {
      if(res.status === 200){
        //console.log(...res.data)
        setClasses([]) //! Pašalinti prieš buildinant
        res.data.forEach((data) => {
          console.log(data)
          data.action = <Link className='text-violet-500 hover:text-violet-700' to={'/dashboard/classes/' + data.id}>Daugiau</Link>
          setClasses(classe => [...classe, data])
          setDataLoaded({done: true, sucssess: true, items: res.data.length})
        })
      }
    })
    .catch(err => {
      setClasses([]) //! Pašalinti prieš buildinant
      //console.log(err.response.data)
      setClasses(guardians => [...guardians, err.response.data])
      setDataLoaded({done: true, sucssess: false, items: 0})
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
    <h2>Klasės</h2>
      {!dataLoaded.done
      ? <Spinner />
      : dataLoaded.sucssess
        ?dataLoaded.items
          ? <>
              <ClosingAlert type='error' message={errorMsg} show={showError2} updateState={(value) => {setShowError2(value)}} />
              <ClosingAlert type='success' message='Moksleiviai sėkmingai paskirstyti į klases' show={showError} updateState={(value) => {setShowError(value)}} />
              <Button text='Paskirstyti moksleivius' onClick={() => sortStudents()} />
              <Table columns={tableColumns} data={classes} />
            </>
          : <ClosingAlert type='warning' message='Klasių nerasta' />
        : <ClosingAlert type='error' message='Kažkas nepavyko, bendykite vėl šiek tiek vėliau' />
      }
    {authUser().roles.admin && 
    <Modal showAddBtn={true} title='Nauja klasė' saveText='Sukurti' submitFunction={() => createClass()}>
      <div className='pt-5'>
        <Input
          label='Pavadinimas'
          name='name'
          type='text'
          value={formData.name}
          onChange={(e)=>setFormData({...formData, name: e.target.value})}
          />
        <div className='pt-0'>
          <label className='text-gray-500' htmlFor="class">Lygis</label>
          <Select
          name='class'
          onChange={(e)=>setFormData({...formData, grade: e.value})}
          options={
            ['1', '2', '3', '4' ].map(grade => {
              return ({ value: grade, label: grade + '-os klasės' })
            })
          } />
        </div>
      </div>
    </Modal>
}
    </>
  )
}